import { not } from 'ramda';
import { createSelector } from 'reselect';

import { DISCONNECTED, RECONNECTING } from '@ezugi/constants';

import { RootState } from '../types';

export const roundSelector = (state: RootState) => state.round;
export const roundIdSelector = (state: RootState) => state.round.roundId;
export const roundStatusSelector = (state: RootState) => state.round.roundStatus;
export const shuffleTimeSelector = (state: RootState) => state.round.isShuffleTime;
export const cardReceivedSelector = (state: RootState) => state.round.cardReceived;
export const winAmountSelector = (state: RootState) => state.round.winAmount;

export const gameResultSelector = createSelector(
  roundSelector,
  (round) => round.gameResults || {},
);

export const gameTimerSelector = createSelector(roundSelector, (round) => ({
  timeLeft: round.timeLeft,
  totalTime: round.totalTime,
  roundStartTimestamp: round.roundStartTimestamp,
  roundTime: round.roundTime,
  messageTimestamp: round.messageTimestamp,
}));

export const isDisconnectedSelector = createSelector(
  roundStatusSelector,
  (status) => status === DISCONNECTED,
);

export const canPlaceBetsSelector = createSelector(
  roundSelector,
  (round) => round.canPlaceBets
);

export const idleGameBoardSelector = createSelector(canPlaceBetsSelector, not);

export const shouldCelebrateSelector = createSelector(
  roundSelector,
  (round) => round.shouldCelebrate ?? false
);

export const isDisconnectedOrReconnectingSelector = createSelector(
  roundStatusSelector,
  (status) => status === DISCONNECTED || status === RECONNECTING,
);
